/* global SentryUserData */

import {init, configureScope} from '@sentry/browser';

import {
    DenyURLs,
    IgnoreErrors,
    describeStackOverflow,
    isLocalCopy,
    isThirdPartyEvent,
    matchesError,
} from 'shared/sentry-rules';

/* jQuery is served as a bundle of its own, so everything expecting it fails at once when that one
   file did not arrive. The page is broken then, but by the network rather than by us. A jQuery that
   is present and still reported missing would be worth seeing, which is what the check leaves in. */
const MissingJQueryPattern = /jQuery is not defined|find variable: jQuery/;

const isMissingJQuery = event => !window.jQuery && matchesError(event, MissingJQueryPattern);

if (process.env.NODE_ENV === 'production') {
    init({
        dsn: 'https://c791a73cda4e451f961a8df94d8b7ec7@sentry.cosmocode.de/20',
        environment: window.SentryEnvironment,
        release: window.SentryRelease,
        denyUrls: DenyURLs,
        ignoreErrors: IgnoreErrors,
        beforeSend(event) {
            if (isThirdPartyEvent(event) || isLocalCopy(event) || isMissingJQuery(event)) return null;

            return describeStackOverflow(event);
        },
    });

    const user = window.SentryUserData ? {...SentryUserData} : null;

    if (user) configureScope(scope => scope.setUser(user));
}
